import { PermissionEnum } from "@saleor/graphql";
import { mapEdgesToItems } from "@saleor/utils/maps";

import { AppData, useExternalApp } from "./components/ExternalAppContext";

export interface Extension {
  id: string;
  app: any;
  accessToken: string;
  permissions: PermissionEnum[];
  label: string;
  mount: any;
  url: string;
  open(): void;
}
export const extensionMountPoints = {
  PRODUCT_LIST: [],
  PRODUCT_DETAILS: [],
  NAVIGATION_SIDEBAR: []
};

const filterAndMapToTarget = (
  extensions: any,
  openApp: (appData: AppData) => void
): Extension[] =>
  extensions.map(
    ({ id, accessToken, permissions, url, label, mount, target, app }) => ({
      id,
      app,
      accessToken,
      permissions: permissions.map(({ code }) => code),
      url,
      label,
      mount,
      open: () =>
        openApp({ id: app.id, appToken: accessToken, src: url, label, target })
    })
  );

export const mapToMenuItems = (extensions: Extension[]) =>
  extensions.map(({ label, id, open }) => ({
    label,
    testId: `extension-${id}`,
    onSelect: open
  }));

export const useExtensions = <T>(mountList: T[]): Record<any, Extension[]> => {
  const { openApp } = useExternalApp();

  const extensions = filterAndMapToTarget(mapEdgesToItems(null) || [], openApp);

  const extensionsMap = mountList.reduce(
    (extensionsMap, mount) => ({ ...extensionsMap, [mount as any]: [] }),
    {} as Record<any, Extension[]>
  );

  return extensions.reduce(
    (prevExtensionsMap, extension) => ({
      ...prevExtensionsMap,
      [extension.mount]: [
        ...(prevExtensionsMap[extension.mount] || []),
        extension
      ]
    }),
    extensionsMap
  );
};
